import { render } from "./SeatModal.vue?vue&type=template&id=deb8285a&ts=true"
import script from "./SeatModal.vue?vue&type=script&lang=ts"
export * from "./SeatModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__